import { Build, Component, Element, h, Host, Prop, State } from '@stencil/core';
import { getInstance } from '../../../services/funnels/funnel-data.service';

@Component({
    tag: 'web-vehicle-funnel-entrance',
    shadow: false
})
export class VehicleFunnelEntrance {
    @Prop() funnelUrl: string;
    @Prop() funnelTitle: string;
    @Prop() countryCode: string;
    @Prop() placeholderText: string;
    @Prop() buttonText: string;
    @Prop() vehicleType: string;
    @Prop() hideInput: boolean;

    @Element() rootElement: HTMLWebVehicleFunnelEntranceElement;

    @State() licensePlate: string;

    async componentWillLoad() {
        if (Build.isBrowser) {
            const funnelService = getInstance<string>();
            this.licensePlate = await funnelService.getStoredValue(this.vehicleType);
        }
    }

    public handleSubmit = async (event: Event) => {
        event.preventDefault();

        const funnelService = getInstance<string>();
        const form = event.target as HTMLFormElement;
        const licensePlate = form.license_plate?.value;

        await funnelService.submitValue(this.vehicleType, licensePlate, this.funnelUrl);
    };

    render() {
        const { licensePlate, countryCode, placeholderText, funnelTitle, buttonText, hideInput } = this;
        return (
            <Host>
                {funnelTitle && <h1>{funnelTitle}</h1>}
                <form onSubmit={(e) => this.handleSubmit(e)}>
                    {hideInput !== true && (
                        <div class="fieldset">
                            <web-license-plate
                                name="license_plate"
                                country-code={countryCode}
                                placeholder-text={placeholderText}
                                value={licensePlate}
                            ></web-license-plate>
                        </div>
                    )}
                    <div class="fieldset">
                        <web-button buttonText={buttonText}></web-button>
                    </div>
                </form>
            </Host>
        );
    }
}
